module.exports = __webpack_public_path__ + "25be3089db04d933515295887dddeddf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/book-stack.png
// module id = 2607
// module chunks = 0